import moment from 'moment';

export const formatDate = (date, format, locale) =>
    moment(date)
        .locale(locale)
        .format(format);
export const formatRemainingDays = (date, locale) =>
    moment(date)
        .locale(locale)
        .fromNow();

export default (value, format, locale) => {
    if (value instanceof Date || moment.isMoment(value)) {
        return format === 'remaining' ? formatRemainingDays(value, locale) : formatDate(value, format, locale);
    }
};
